export type GeneralErrorTranslation = {
  forbidden: ErrorTranslation;
  general: ErrorTranslation;
  goBack: string;
  http: {
    404: string;
    500: string;
  };
  logIn: string;
  notAuthorized: ErrorTranslation;
  notFound: ErrorTranslation;
  phoneOrEmailRequired: string;
  waitingForApproval: ErrorTranslation;
};

type ErrorTranslation = {
  message: string;
  subMessage?: string;
};

export const generalErrorTranslation: GeneralErrorTranslation = {
  forbidden: {
    message: 'Nie masz dostępu do tego zasobu',
    subMessage: 'Jeżeli uważasz, że to błąd, skontaktuj się ze swoim przełożonym',
  },
  general: {
    message: 'Wystąpił nieoczekiwany błąd',
    subMessage: 'Nasz zespół został poinformowany. Spróbuj ponownie później.',
  },
  goBack: 'Wróć',
  http: {
    404: 'Nie znaleziono żądanego zasobu',
    500: 'Wystąpił nieoczekiwany błąd',
  },
  logIn: 'Zaloguj się',
  notAuthorized: {
    message: 'Twoja sesja wygasła',
    subMessage: 'Za chwilę nastąpi przekierowanie na stronę logowania',
  },
  notFound: {
    message: 'Strona nie istnieje!',
  },
  phoneOrEmailRequired: 'Numer telefonu lub email jest wymagany',
  waitingForApproval: {
    message: 'Twoje konto oczekuje na zatwierdzenie',
    subMessage: 'Poinformujemy Cię, gdy zostanie zatwierdzone.',
  },
};
